export const langGlobalStats = {
  fr: {
    title: `Stats globales`,
    tabTitle: `Nombre de sessions et durée cumulée`,
    nbTitle: `Nombre de sessions`,
    nbCumulTitle: ` (cumul mensuel)`,
    nbDetailTitle: ` (détail mensuel)`,
    durationTitle: `Durée des sessions`,
    durationCumulTitle: ` (cumul mensuel)`,
    durationDetailTitle: ` (détail mensuel)`,
    cumulate: ` Cumuler`,
    noStats: `Vous n'avez pas de session enregistrée, donc pas de stats globales disponibles.`,
    calendarTitle: `Calendrier des sessions`,
    calendarX: `Jour de l'année`,
    calendarY: `Année`,
    nbX: ``,
    durationX: ``,
    nbY: `nombre sessions total`,
    durationY: `durée totale`,
    maxSpeedDistanceTitle: `Vitesse max et Distance par session`,
    distance: `Distance`,
    maxSpeed: `Vitesse max`,
    distanceX: `Date`,
    distanceY: `km`,
    maxSpeedX: `Date`,
    maxSpeedY: `knt`,
  },
  eng: {
    title: `Global stats`,
    tabTitle: `Number of sessions and total duration`,
    nbTitle: `Number of sessions`,
    nbCumulTitle: ` (monthly total)`,
    nbDetailTitle: ` (monthly detail)`,
    durationTitle: `Sessions duration`,
    durationCumulTitle: ` (monthly total)`,
    durationDetailTitle: ` (monthly detail)`,
    cumulate: ` Cumulate`,
    noStats: `You have no saved session, so no global stats available.`,
    calendarTitle: `Sessions calendar`,
    calendarX: `Day of year`,
    calendarY: `Year`,
    nbX: ``,
    durationX: ``,
    nbY: `total sessions nb`,
    durationY: `total duration`,
    maxSpeedDistanceTitle: `Max speed and Distance per session`,
    distance: `Distance`,
    maxSpeed: `Max speed`,
    distanceX: `Date`,
    distanceY: `km`,
    maxSpeedX: `Date`,
    maxSpeedY: `knt`,
  },
}
